import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgActivation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 6,
	viewBox: "0 0 6 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 3,
		cy: 3,
		r: 3,
		fill: "#50566E"
	})
});
export default SvgActivation;
